import React from 'react'
import injectStyles from 'react-jss'
import HorizontalBar from './HorizontalBar'
import AxisLabels from './AxisLabels'
import classNames from 'classnames'
import Marker from './Marker'

const styles = {
  container: {
    backgroundColor: 'white',
    padding: '27px 20px 30px',
    position: 'relative',
    overflow: 'hidden',
  },
  blue: { color: 'blue' },
}

/**
 * @typedef BulletChartProps
 * @property {number} percentFilled Percentage of how much the bar will be
 * filled
 * @property {Array<AxisLabel>} axisLabels See './AxisLables' for type
 * definition.
 * @property {string} actualValueLabel The label describing the actual value
 * @property {string} actualValueClassName Optionally re-style the actual value
 * label
 *
 * A Bullet chart.
 * @param {BulletChartProps} props
 */
const BulletChart = props => (
  <div className={classNames(props.classes.container, props.className)}>
    <HorizontalBar
      percentFilled={props.percentFilled}
      className={props.horizontalBarClassName}
      innerClassName={props.horizontalBarInnerClassName}
    >
      {props.markers && props.axisLabels.length > 0
        ? props.markers.map(({ label, percent }) => (
            <Marker style={{ left: percent + '%' }} />
          ))
        : null}
    </HorizontalBar>
    <AxisLabels
      axisLabels={props.axisLabels}
      /* Indicates the value of the target */
      axisLabels2={
        props.actualValueLabel
          ? [
              {
                label: props.actualValueLabel,
                percent: props.percentFilled,
                innerClassName: props.actualValueClassName,
              },
            ]
          : null
      }
      axisLabels3={props.markers}
    />
    {props.children}
  </div>
)

export default injectStyles(styles)(BulletChart)



// WEBPACK FOOTER //
// ./src/Components/Stats/BulletChartRaw/index.js